module.exports = __webpack_public_path__ + "img/GAME_MARBLES2.a547997d.jpg";